import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  BarController,
  BarElement,
  CategoryScale,
  LinearScale,
  Tooltip,
  Legend,
} from "chart.js"

Chart.register(BarController, BarElement, CategoryScale, LinearScale, Tooltip, Legend)

// data-controller="energy-chart"
// data-energy-chart-labels-value="[...]"   JSON array of month strings
// data-energy-chart-renewable-value="[...]"
// data-energy-chart-genset-value="[...]"
// data-energy-chart-other-value="[...]"
// data-energy-chart-label-renewable-value="Renewable"
// data-energy-chart-label-genset-value="Genset"
// data-energy-chart-label-other-value="Other"

export default class extends Controller {
  static targets = ["canvas"]
  static values  = {
    labels:         Array,
    renewable:      Array,
    genset:         Array,
    other:          Array,
    labelRenewable: String,
    labelGenset:    String,
    labelOther:     String,
  }

  connect() {
    const ctx = this.canvasTarget.getContext("2d")

    const datasets = []

    if (this.renewableValue.some(v => v > 0)) {
      datasets.push({
        label:           this.labelRenewableValue,
        data:            this.renewableValue,
        backgroundColor: "#16a34a",
        borderRadius:    { topLeft: 4, topRight: 4, bottomLeft: 0, bottomRight: 0 },
        borderSkipped:   false,
        stack:           "energy",
      })
    }

    if (this.otherValue.some(v => v > 0)) {
      datasets.push({
        label:           this.labelOtherValue,
        data:            this.otherValue,
        backgroundColor: "#60a5fa",
        borderRadius:    0,
        borderSkipped:   false,
        stack:           "energy",
      })
    }

    if (this.gensetValue.some(v => v > 0)) {
      datasets.push({
        label:           this.labelGensetValue,
        data:            this.gensetValue,
        backgroundColor: "#ca8a04",
        borderRadius:    { topLeft: 0, topRight: 0, bottomLeft: 4, bottomRight: 4 },
        borderSkipped:   false,
        stack:           "energy",
      })
    }

    this.chart = new Chart(ctx, {
      type: "bar",
      data: {
        labels:   this.labelsValue,
        datasets,
      },
      options: {
        responsive:          true,
        maintainAspectRatio: true,
        aspectRatio:         3,
        plugins: {
          legend: {
            position: "bottom",
            labels: {
              boxWidth:  12,
              boxHeight: 12,
              padding:   16,
              font:      { size: 12 },
              color:     "#6b7280",
            },
          },
          tooltip: {
            callbacks: {
              label: (ctx) => {
                const v = ctx.parsed.y
                if (v == null || v === 0) return null
                const formatted = v >= 1000
                  ? `${(v / 1000).toLocaleString(undefined, { maximumFractionDigits: 1 })} MWh`
                  : `${Math.round(v).toLocaleString()} kWh`
                return ` ${ctx.dataset.label}: ${formatted}`
              },
              footer: (items) => {
                const total = items.reduce((s, i) => s + (i.parsed.y || 0), 0)
                if (total === 0) return ""
                const formatted = total >= 1000
                  ? `${(total / 1000).toLocaleString(undefined, { maximumFractionDigits: 1 })} MWh`
                  : `${Math.round(total).toLocaleString()} kWh`
                return `Total: ${formatted}`
              },
            },
            footerFont:   { weight: "bold" },
            padding:      10,
            cornerRadius: 6,
          },
        },
        scales: {
          x: {
            stacked: true,
            grid:    { display: false },
            ticks:   { color: "#6b7280", font: { size: 11 } },
          },
          y: {
            stacked:   true,
            beginAtZero: true,
            grid:   { color: "#f3f4f6" },
            border: { dash: [4, 4] },
            ticks: {
              color: "#9ca3af",
              font:  { size: 10 },
              callback: (v) => v >= 1000 ? `${v / 1000}k` : v,
            },
          },
        },
      },
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
